<!--
 * @Author: 仙道
 * @Date: 2022-06-22 20:33:36
 * @LastEditTime: 2022-09-24 13:37:31
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/components/tools/Workbench.vue
-->
<template>
  <a-modal
    :confirmLoading="confirmLoading"
    :title="title"
    :visible="visible"
    :width="modalWidth"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <div class="bench-box">
        <div class="bench-box-list px-15px">
          <div :key="key" class="bench-box-list-item" v-for="([key,value]) in benchData">
            <div class="w-100px">
              <img alt src="http://iot.feisjy.com/data/assets/icon/项目3.png" />
            </div>
            <div class="flex-1 flex flex-col">
              <div class="bench-box-list-item-head flex justify-between">
                <span>{{value.title}}</span>
                <a-button
                  :disabled="value.status===1"
                  @click="addPanel(value,key)"
                  size="small"
                >{{value.status===1?'已添加':'添加'}}</a-button>
              </div>
              <div class="bench-box-list-item-desc mt-10px">{{value.desc}}</div>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>

  import { putAction, httpAction } from '@/api/manage'
  import { mapActions, mapGetters } from 'vuex'
  export default {
    name: "WorkbenchSetting",
    data () {
      return {
        title: "添加工作台组件",
        modalWidth: 800,
        visible: false,
        confirmLoading: false,
        validatorRules: {
          oldpassword: {
            rules: [{
              required: true, message: '请输入旧密码!',
            }],
          },
          password: {
            rules: [{
              required: true, message: '请输入新密码!',
            }, {
              validator: this.validateToNextPassword,
            }],
          },
          confirmpassword: {
            rules: [{
              required: true, message: '请确认新密码!',
            }, {
              validator: this.compareToFirstPassword,
            }],
          }
        },
        confirmDirty: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        form: this.$form.createForm(this),
        url: "sys/user/updatePassword",
        username: "",
      }
    },
    created () {
      this.InitWorkbench()
    },
    // computed: {
    //   ...mapGetters['benchData']
    // },
    computed: {

      ...mapGetters(['benchData', 'layoutList'])
    },
    methods: {
      ...mapActions(['InitWorkbench', 'stashLayoutItem']),
      //添加组件
      addPanel (layoutItem, layoutKey) {
        // const maxY = this.layoutList.reduce((pre, cur) => {
        //   return pre < cur.y ? pre : cur.y
        // }, 0)

        const maxY = this.layoutList.length > 0 ? Math.max.apply(Math, this.layoutList.map(list => list.y)) : layoutItem.data.y

        const layoutData = {
          ...layoutItem.data,
          title: layoutItem.title,
          y: maxY + 1,
          x: 0
        }
        const findData = {
          "componentData": JSON.stringify(layoutData),
          "componentDesc": layoutItem.desc,
          "componentIcon": layoutItem.img,
          "componentName": layoutKey,
          "componentTitle": layoutItem.title
        }

        const url = `/custom/sysUserComponent${layoutItem.id ? '/edit' : '/add'}`
        const method = layoutItem.id ? 'put' : 'post'

        httpAction(url, findData, method).then(res => {

          this.stashLayoutItem(
            {
              ...layoutItem.data,
              title: layoutItem.title,
              y: maxY + 1,
              x: 0
            })
        })

      },
      show (uname) {

        this.form.resetFields();
        this.visible = true;
      },
      handleCancel () {
        this.close()
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.disableSubmit = false;
        this.selectedRole = [];
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        that.close();
      },
      validateToNextPassword (rule, value, callback) {
        const form = this.form;
        if (value && this.confirmDirty) {
          form.validateFields(['confirm'], { force: true })
        }
        callback();
      },
      compareToFirstPassword (rule, value, callback) {
        const form = this.form;
        if (value && value !== form.getFieldValue('password')) {
          callback('两次输入的密码不一样！');
        } else {
          callback()
        }
      },
      handleConfirmBlur (e) {
        const value = e.target.value
        this.confirmDirty = this.confirmDirty || !!value
      }

    }
  }
</script>

<style lang="less" scoped>
  .bench-box {
    min-height: 500px;
    overflow-y: scroll;
    &-list {
      display: grid;
      grid-template-columns: 49% 49%;
      grid-gap: 15px 15px;
      &-item {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        padding: 15px;
        border: 1px dashed #c2d6ff;
        border-radius: 8px;
        img {
          width: 70px;
          border-radius: 20px;
        }
        &-head {
          span {
            color: #333;
            font-weight: 700;
            font-size: 17px;
          }
        }
      }
    }
  }
</style>

